define('modules/form_editor/views/editor_dropdown',['require','exports','module','base/collectionview','../../editor/models/editorstate','./editor_dropdown_item','ldsh!../templates/editor_dropdown'],function(require, exports, module) {
  "use strict";
  var CollectionView = require("base/collectionview"),
    EditorState = require("../../editor/models/editorstate");

  module.exports = CollectionView.extend({
    itemView: require("./editor_dropdown_item"),
    itemContainer: ".js-items",
    template: require("ldsh!../templates/editor_dropdown"),

    events: {
      "change .js-first": "updateModel"
    },

    initialize: function() {
      this.collection = this.model.items;
      this.listenTo(this.childVent, "item:add", this.addNewItem);
      this.listenTo(this.childVent, "item:remove", this.removeItem);
    },

    helpers: function () {
      return {
        url: this.model.get('url'),
        isAMP: EditorState.getAMPState()
      };
    },

    //add a new item to the collection, after the "model"
    addNewItem: function(view) {
      this.model.addItemAfter(view.model);
    },

    //remove this model
    removeItem: function(view) {
      this.model.removeItem(view.model);
    },

    updateModel: function() {
      var isFirstValid = this.$(".js-first").is(":checked");
      this.model.setFirstOptionInvalid(isFirstValid);
    },

    onRender: function() {
      this.$el.i18n();
    }
  });
});

